import {useEffect, useState} from 'react';
import api from '../api';

export const CHAT_READ_EVENT = 'rental-chat-read';
export default function useUnreadMessages() {
  const [count, setCount] = useState(null);
  useEffect(() => {
    let stopped = false, timer, sequence = 0;
    const refresh = async () => {
      if (stopped || document.hidden) return;
      const request = ++sequence;
      try {
        const response = await api.get('/chat/unread');
        const next = response.data?.unread_count;
        if (!stopped && request === sequence && Number.isInteger(next) && next >= 0) setCount(next);
      } catch { /* Keep the last known count if the connection is interrupted. */ }
    };
    const poll = async () => { await refresh(); if (!stopped) timer = setTimeout(poll, 5000); };
    poll();
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener(CHAT_READ_EVENT, refresh);
    return () => { stopped = true; clearTimeout(timer); document.removeEventListener('visibilitychange', refresh); window.removeEventListener(CHAT_READ_EVENT, refresh); };
  }, []);
  return count;
}
